// PCB Stackup view
export const PCB_SIZE = {
  width: 200,
  depth: 200,
};
export const OPACITY = 0.9;

export const MATERIAL_COLOR   = 0x800080;
export const MATERIAL_HIGHLIGHT_COLOR = 0xffff00;

export const COPPER_COLOR     = 0xb87333;
export const COPPER_SEGNEMTS  = 8;
export const COPPER_THICKNESS = 3;
export const COPPER_FILL      = 0.8;
export const DEFAULT_INNER_COPPER_WEIGHT = 0.5;
export const DEFAULT_OUTER_COPPER_WEIGHT = 0.5;
export const DEFAULT_NUM_COPPER_LAYERS = 4;

export const CORE_COLOR = 0x0f6322;
export const PREPREG_COLOR = 0x00ff00;

export const MATERIAL_THICKNESS = 10;

export const DEFAULT_SPACE_BETWEEN_MATERIALS = 5;

export const APP_DRAWER_WIDTH = 250;

export const FOIL     = "FOIL";
export const CORE_CAP = "CORE CAP";

export const COPPER   = "COPPER";
export const PREPREG  = "PREPREG";
export const CORE     = "CORE";

export const STACKUP_ROTATION_SPEED = 0.01;

export const MICROSTRIP = 'Microstrip';
export const EMBEDDED_MICROSTRIP = 'Embedded Microstrip';
export const STRIPLINE = 'Stripline';
export const ASYMMETRIC_STRIPLINE = 'Asymmetric Stripline';

export const NOOP = () => {}

export const EDIT_COPPER_FORM = 'editCopper';
export const EDIT_CORE_FORM = 'editCore';
export const EDIT_PREPREG_FORM = 'editPrepreg';
export const EDIT_SETTINGS_FORM = 'editSettings';
export const DK_DECIMALS = 2;
export const DF_DECIMALS = 5;
export const RESINCONTENT_DECIMALS = 1;
export const OZ_DECIMALS = 2;
export const OHM_DECIMALS = 2;
export const PSIN_DECIMALS = 2;
export const COPPER_FILL_PERCENT_DECIMALS = 1;
export const DEFAULT_IMPEDANCE_MHZ = 10000;

export const CHART_COLORS = [
  '#5E2E2D',
  '#6D3945',
  '#754861',
  '#725C7D',
  '#637293',
  '#4C87A1',
  '#349CA3',
  '#36AF9B',
  '#59C08A',
  '#89CD75'
];

export const FILE_EXTENSION = '.sud';

export const REQUEST_QUOTE_FORM = 'requestQuoteForm';



// WEBPACK FOOTER //
// ./src/constants/globals.js